import { motion } from "framer-motion";

const technologies = [
  "VS CODE",
  "GIT",
  "PHOTOSHOP",
  "ILLUSTRATOR",
];

function Row({ reverse = false }) {
  const marqueeItems = [...technologies, ...technologies];

  return (
    <div className="w-full overflow-hidden whitespace-nowrap">
      <motion.div
        className="flex w-max items-center"
        animate={{
          x: reverse ? ["-50%", "0%"] : ["0%", "-50%"],
        }}
        transition={{
          duration: 25,
          ease: "linear",
          repeat: Infinity,
        }}
      >
        {marqueeItems.map((item, index) => (
          <div key={index} className="mx-2 flex shrink-0 items-center sm:mx-3 md:mx-4">
            <img
              src="/star.svg"
              alt=""
              draggable={false}
              className="h-4 w-4 shrink-0 select-none sm:h-5 sm:w-5 md:h-6 md:w-6 lg:h-8 lg:w-8"
            />

            <h2 className="ml-4 whitespace-nowrap font-minecraft text-3xl uppercase leading-none text-black sm:ml-5 sm:text-4xl md:ml-6 md:text-5xl lg:ml-9 lg:text-7xl">
              {item}
            </h2>
          </div>
        ))}
      </motion.div>
    </div>
  );
}

export default function MarqueeSection() {
  return (
    <section id="experience" className="w-full overflow-hidden py-6 sm:py-7 md:py-8 lg:py-9">
      <Row />

      <div className="h-3 sm:h-4 md:h-5 lg:h-6" />

      <Row reverse />
    </section>
  );
}